import { observable, action } from 'mobx';

export default class DropShipUps {
	@observable isValid = false;
	@observable isAmbiguous = false;
	@observable.ref candidates = [];
	@observable isServiceDown = false;

	constructor(response) {
		this.init(response);
	}

	@action
	init(response) {
		this.isValid = response.IsValid;
		this.isAmbiguous = response.IsAmbiguous;
		this.isServiceDown = response.IsServiceDown;
		this.candidates =
			response.IsAmbiguous || response.Candidate.length > 0
				? response.Candidate.map((dropship, index) => ({
						id: `candidate-${index}`,
						address1: dropship.Address1,
						address2: dropship.Address2,
						addressLine: dropship.AddressLine,
						politicalDivision1: dropship.PoliticalDivision1,
						politicalDivision2: dropship.PoliticalDivision2,
						postcodePrimaryLow: dropship.PostcodePrimaryLow,
						countryCode: dropship.CountryCode,
					}))
				: [];
	}
}



// WEBPACK FOOTER //
// ./src/api/models/DropshipUps.js